import { AppEnv } from './env-types';
import { merge } from 'lodash';
import { npdEnvDefaults } from './env-defaults';

window.MLBBest = {
  env: merge(npdEnvDefaults, {
    appEnv: AppEnv.DEV,
    piaApiBaseUrl: 'https://pia-dev.best-gcp-npd.mlbinfra.com',
  }),
};
